/*
 * Server Filter Processor Service
 * 
 * Transforms filter objects from kendo data sources into a filter parameter for the server api
 * 
 * Angular module: trackerbase-app.services.server-filter-processor-service
 * Service Name: ServerFilterProcessor 
 *
 */

import angular from "angular";

function translateSchedulerFilter (filterObj) {
    let filterParts = [];
    if (angular.isDefined(filterObj["logic"])) {
        let numSubFilterParts = filterObj["filters"].length;

        if (numSubFilterParts === 0) {
            // An orphan logic block. Don't bother returning the meaningless logic op.
            return [];
        }

        //Need to process the sub-filter parts.

        if (numSubFilterParts > 1) {
            //we've got ourselves a compound operation here.
            //attach the logic operation value and continue further processing
            filterParts.push(filterObj["logic"]);
        }
        else {
            // Remaining case: 1 sub-filter part.
            //If this is a compound logic item, it can be safely left out of the result stream.
            //If this is a non-compound item (not, noop), it has to be left in.

            if ((filterObj["logic"] === "not") || (filterObj["logic"] === "noop")) {
                filterParts.push(filterObj["logic"]);
            }
        }


        let subFilterParts = [];
        filterObj["filters"].forEach(function(filterSubObj) {
            let translatedSubFilterParts = translateSchedulerFilter(filterSubObj);
            Array.prototype.push.apply(subFilterParts, translatedSubFilterParts);
        });

        Array.prototype.push.apply(filterParts, subFilterParts);
    }
    else {
        filterParts.push(
            String(filterObj.field) +
            "|" +
            String(filterObj.value)
        );
    }

    return filterParts;
}

function unrollScope(scopeTracker) {

    let scopeUnrollCompleted = false;
    while (!scopeUnrollCompleted) {
        if (scopeTracker.length === 0) {
            break;
        }
        let currentScope = scopeTracker.pop();
        currentScope.argsNeeded--;
        if (currentScope.argsNeeded > 0) {
            scopeTracker.push(currentScope);
            scopeUnrollCompleted = true;
        }
        //By not doing the push and complete,
        //we will toss the current scope and
        //unroll the lower scope.
    }
}

function checkAndCompleteTranslatedFilter(filterArr) {
    let checkPassed = false;
    while (!checkPassed) {

        let scopeTracker = [];
        let filterElements = filterArr.length;

        for (let filterArrIdx = 0; filterArrIdx < filterElements; filterArrIdx++) {

            switch (filterArr[filterArrIdx]) {
                case "or":
                    scopeTracker.push({ operator: "or", argsNeeded: 2});
                    break;
                case "and":
                    scopeTracker.push({ operator: "and", argsNeeded: 2});
                    break;
                case "not":
                    scopeTracker.push({ operator: "not", argsNeeded: 1});
                    break;
                case "noop":
                    scopeTracker.push({ operator: "noop", argsNeeded: 1});
                    break;
                default:
                    unrollScope(scopeTracker);
                    break;
            }

            if (scopeTracker.length === 0) {
                if (filterArrIdx === (filterElements - 1)) {
                    checkPassed = true;
                }
                else {
                    //Early statement termination. Break, then prepend a copy of the first element and restart the check.
                    break;
                }
            }
        }

        if (!checkPassed) {
            let filterInitialToken = angular.copy(filterArr[0]);
            filterArr.unshift(filterInitialToken);
        }
    }
}

class ServerFilterProcessorService {
    constructor() {}

    toString() {
        return "Server Filter Processor Service";
    }

    // TranslateSchedulerFilter(filterObj) {
    //     return translateSchedulerFilter(filterObj);
    // }
    // CheckAndCompleteTranslatedFilter(filterArr) {
    //     return checkAndCompleteTranslatedFilter(filterArr);
    // }

    ProcessFilterForServer(filterObj, joinStr) {
        let filterParts = translateSchedulerFilter(filterObj);
        checkAndCompleteTranslatedFilter(filterParts);
        return filterParts.join(joinStr);
    }
}

ServerFilterProcessorService.$inject = [];

export default angular
    .module("trackerbase-app.services.server-filter-processor-service",[
    ])
    .service("ServerFilterProcessor", ServerFilterProcessorService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/ServerFilterProcessorService.js
// module id = awFq
// module chunks = 1